var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var NewFileOutline = function (_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V12H18V9H13V4H6V20H12V22H6ZM18.3 14.525L19.375 15.6L15.5 19.45V20.5H16.55L20.425 16.65L21.475 17.7L17.175 22H14V18.825L18.3 14.525ZM21.475 17.7L18.3 14.525L19.75 13.075C19.9333 12.8917 20.1667 12.8 20.45 12.8C20.7333 12.8 20.9667 12.8917 21.15 13.075L22.925 14.85C23.1083 15.0333 23.2 15.2667 23.2 15.55C23.2 15.8333 23.1083 16.0667 22.925 16.25L21.475 17.7Z", fill: color }) })));
};
